module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"headline":" Was unsere Mitarbeiter zu sagen haben","title":"Wir sind #SIG"},"en":{"headline":"What our people have to say","title":"We are #SIG"},"it":{"headline":"","title":""},"lt":{"headline":"Ką sako mūsų komanda?","title":"Mes esame #SIG"},"pl":{"headline":"Co mówi nasz team?","title":"Opinie członków zespołu"}}')
  delete Component.options._Ctor
}
